import { get } from 'app/utils/axios/kheti'
import { Livestock } from '../models/farmer'
import {CropsWithCategory} from "app/farmer360/models/crop.ts";

const fetchAllLivestocks = async () => {
  try {
    const url = '/farmer-360/v1/farmer/livestock'
    const response = await get<Livestock[]>(url)
    return Object.entries(response)
        .filter(([key]) => key !== "api-trace-id")
        .map(([, value]) => value) as Livestock[];
  } catch (e) {
    return null
  }
}

export default fetchAllLivestocks
